import { XmlSchemaParticle } from './XmlSchemaParticle';

/**
 * Common type for items that can serve as the particle of a group.
 */
export abstract class XmlSchemaGroupParticle extends XmlSchemaParticle {}
